module.exports = __webpack_public_path__ + "static/assets/40a1214087f2d8e5487c2b0192323837.svg";